'use client';

import React, { memo, useLayoutEffect } from 'react';
import PaymentMethodsModal from '@/app/[locale]/(account)/account/components/payment-methods-modal';
import { type ViewType } from '@/app/[locale]/(account)/account/deposit';
import DepositCryptoDetailsSkeleton from '@/components/common/skeletons/deposit-crypto-details-skeleton';
import { PAYMENT_TYPES } from '@/constants';
import { type FullMethod } from '@/hooks/usePaymentMethodsWithNetworks';
import CreditCards from './credit-cards';
import DepositCryptoDetails from './deposit-crypto-details';
import DepositFiat from './deposit-fiat';

type DepositPaymentMethodDetailsProps = {
  view: ViewType;
  setView: (view: ViewType) => void;
  selectedMethod?: FullMethod;
  setSelectedMethod?: (method?: FullMethod) => void;
};

const DepositPaymentMethodDetails = ({
  view,
  setView,
  selectedMethod,
  setSelectedMethod,
}: DepositPaymentMethodDetailsProps) => {
  // const mountKey = `${selectedMethod?.currencyCode}-${selectedMethod?.networkOptions?.length}`;

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  switch (view) {
    case 'CRYPTO_DETAILS':
      return (
        <DepositCryptoDetails
          setView={setView}
          selectedMethod={selectedMethod}
          setSelectedMethod={setSelectedMethod}
        />
      );
    case 'OTHER_COINS':
      return (
        <PaymentMethodsModal
          paymentType={PAYMENT_TYPES.DEPOSITS}
          setView={setView}
          selectedMethod={selectedMethod}
          setSelectedMethod={setSelectedMethod}
        />
      );
    case 'FIAT':
      return <DepositFiat />;
    case 'CREDIT_CARDS':
      return <CreditCards />;
    default:
      return <DepositCryptoDetailsSkeleton />;
  }
};

export default memo(DepositPaymentMethodDetails);
